#import "../fragments/audience-sms-membership-stats-realtime-fragment.graphql"

query GetAudienceSmsMembershipStats($audienceId: ID!) {
    audience(id: $audienceId) {
        ...AudienceSmsMembershipStatsRealtime
    }
}
